import styled from 'styled-components';

export const ConfirmationStyle = styled.div`
  background: ${(props) => props.theme.primary.primary50};
  min-height: -webkit-fill-available;
  min-height: 100vh;
  text-align: center;
  padding: 120px 16px 0px;
  display: flex;
  align-items: center;
`;
